import {type GuidedV2LinkTag} from '../../models/quick-link';
import {type QdsImportance} from '../../models/ui';
import {h} from '@stencil/core';
import {type labelProviderInterface} from '../../../LabelProviderInterface';
import {isMobile} from '../../../../utils/media';

export const GuidedV2LinkTagRender = (props: {
  tag:GuidedV2LinkTag,
  labelProvider?: labelProviderInterface

}) =>{
    const {tag} = props;
    const importance:QdsImportance = tag?.importance ?? 'standard';
    // const text = tag?.tagMarkup as string ?? tag.tagText; //qds-tag doesn't allow markup within elements



    if(!tag.tagText || tag.tagText == '')
      return <span class="invalid-tag" data-value={JSON.stringify(tag)}></span>;

    let text = tag.tagText;
    if (props.labelProvider) {
      text = props.labelProvider('guided-v2.quick-link.tags.' + tag.type, tag.tagText);
    }

    return (
      <qds-tag
        status={tag.color}
        importance={importance}
        text={text}
        icon-name={tag.iconName}
        size={ isMobile() ? 'small' : 'standard'}
      />
    );
};
